module.exports = __webpack_public_path__ + "img/blue-diamond.067d452d.png";